/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import Icon from '@mercadoni/sinister/dist/cjs/Icon'
import AccountMenu from '@mercadoni/sinister/dist/cjs/accountMenu'
import { Drawer } from 'antd'
import { FC, useState } from 'react'
import styled from 'styled-components'
import Button from './decorators/desktop/Button'
import Dropdown from './decorators/desktop/Dropdown'
import DrawerHeader from './decorators/mobile/DrawerHeader'

const StyledDrawer = styled(Drawer)`
  & .ant-drawer-header {
    padding: 0;
  }

  & .ant-drawer-body {
    padding: 20px;
  }
`

const StyledButtonMobile = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  gap: 0;
  border-radius: 0;
  border: none;
  padding: 0;
  cursor: pointer;
  color: var(--app-header-color-mobile-v3, var(--color-white));
`

interface AccountLayoutProps {
  className?: string
}

const AccountLayout: FC<AccountLayoutProps> = ({ className }) => {
  const { onClickAccountOption, copies, isMobile } = useHeaderContext()
  const [open, setOpen] = useState(false)

  const onClose = () => {
    setOpen(false)
  }

  const onOpen = () => {
    setOpen(true)
  }

  const onClickOption = (value: any) => {
    onClickAccountOption?.(value)
    onClose()
  }

  return isMobile ? (
    <>
      <StyledButtonMobile onClick={onOpen} className={className}>
        <Icon size={24} className="ph-user" aria-label="Account" />
      </StyledButtonMobile>
      <StyledDrawer
        title={<DrawerHeader onClose={onClose} />}
        placement="bottom"
        onClose={onClose}
        open={open}
        closable={false}
      >
        <AccountMenu onClickOption={onClickOption} copies={copies} />
      </StyledDrawer>
    </>
  ) : (
    <Dropdown>
      <Button className={className} />
    </Dropdown>
  )
}

export default AccountLayout
